/* eslint-disable max-len */
import { call, put, takeEvery } from "redux-saga/effects";
import Env from "Consts/env";
import {
	ActionsAppliedPromotion,
	failureAppliedPromotion,
	loadAppliedPromotionSuccess,
	loadGetAppliedPromotion,
	API_PROMOTION,
} from "./actions";

// Function Fetch AppliedPromotion
function* loadDataAppliedPromotion(params = {}) {

	try {

		yield put(loadGetAppliedPromotion());

		const endpoint = API_PROMOTION;
		const headers = { ...Env.HEADERS, cookie: params.cookie };
		const method = "GET";
		const options = { headers, method };

		const response = yield call(fetch, endpoint, options);
		if (typeof response.status !== "undefined" && response.status >= 200 && response.status < 300) {

			const self = yield response.json();

			yield put(loadAppliedPromotionSuccess(self));

		} else {

			throw response;

		}

	} catch (err) {

		yield put(failureAppliedPromotion(err));

	}

}

export default function* rootSaga() {

	yield takeEvery(ActionsAppliedPromotion.GET_APPLIED_PROMOTION, loadDataAppliedPromotion);

}
